export default function CodeMirrorProperties() {
	return {
		token: function(stream, state) {
			var sol = stream.sol() || state.afterSection;
			var eol = stream.eol();

			state.afterSection = false;

			if (sol) {
				if (state.nextMultiline) {
					state.inMultiline = true;
					state.nextMultiline = false;
				} else {
					state.position = "def";
				}
			}

			if (eol && ! state.nextMultiline) {
				state.inMultiline = false;
				state.position = "def";
			}

			if (sol) {
				while(stream.eatSpace());
			}

			if (stream.match("input.", true, true)) {
				return "keyword";
			} else if (stream.match(/^\S{8}-\S{4}-\S{4}-\S{4}-\S{12}/, true, true)) {
				return "number"
			}

			var ch = stream.next();

			if (ch === "#") {
				state.position = "comment";
				stream.skipToEnd();
				return "comment";
			} else if (sol && ch === "[") {
				state.afterSection = true;
				stream.skipTo("]"); stream.eat("]");
				return "header";
			} else if (ch === "=") {
				state.position = "quote";
				return null;
			} else if (ch === "\"") {
				stream.skipTo("\""); stream.eat("\"");
				return "number";
			} if (/\d/.test(ch)) {
				stream.eatWhile(/[\w.]/);
				return "number";
			} else if (ch === "[") {
				stream.skipTo("]"); stream.eat("]");
				return "quote";
			} else if (/\w/.test(ch)) {
				stream.eatWhile(/(\w|\d)/);
			}

			return state.position;
		},

		startState: function() {
			return {
				position : "def",       // Current position, "def", "quote" or "comment"
				nextMultiline : false,  // Is the next line multiline value
				inMultiline : false,    // Is the current line a multiline value
				afterSection : false    // Did we just open a section
			};
		}

	};
}

